var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { computed, observable, makeObservable } from 'mobx';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { runtime } from '../../runtime/Runtime';
import { SvgFilterDefs } from '../../../packages/Exotic/areas/SvgImage/components/SvgFilterDefs';
export class ActorRenderer {
    parent;
    actorComponentChildrenForInnerAspect;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get computedSkeleton() {
        const at = this.actor.activeOf.structure;
        if (!at)
            return React.createElement("div", { "data-aspect": "inner" });
        return at.skeletonResultingFromAttachedTrait;
    }
    get computedSkeletonAsString() {
        return runtime.availablePackages.Edit
            ? runtime.availablePackages.Edit.libs.reactElementToJSXString(this.computedSkeleton)
            : '';
    }
    get computedComponent() {
        return this.aspectifyJsxTemplate(this.computedSkeleton);
    }
    get computedComponentAsString() {
        if (!this.computedComponent)
            return '';
        if (runtime.availablePackages.Edit) {
            return runtime.availablePackages.Edit.libs.reactElementToJSXString(this.computedComponent);
        }
        return '';
    }
    getActorByIdProp(idProp, actor) {
        const isOption = idProp.split('option');
        if (isOption.length > 1) {
            return actor.context.question.options[parseInt(isOption[1]) - 1];
        }
    }
    aspectifyJsxTemplate(currentNodeOrNodes, p = {}) {
        const { innerChildren } = p;
        if (Array.isArray(currentNodeOrNodes)) {
            return currentNodeOrNodes.map(node => this.aspectifyJsxTemplate(node, p));
        }
        const currentNode = currentNodeOrNodes;
        if (!currentNode || ['string', 'number'].includes(typeof currentNode))
            return currentNode;
        let return_node = currentNode;
        if (!currentNode.props)
            console.log(typeof currentNode);
        const doesCurrentNodeHaveChildren = !!currentNode.props.children;
        const hasActorId = currentNode.props.id && currentNode.props.id.includes('actor_');
        const shouldCurrentNodeBeActorified = hasActorId;
        if (shouldCurrentNodeBeActorified) {
            const actor = this.getActorByIdProp(currentNode.props.id.split('actor_')[1].split('__')[0], this.actor);
            if (!actor) {
                return currentNode;
            }
            if (actor !== this.actor) {
                return actor.actorRenderer.aspectifyJsxTemplate(currentNode, { ...p, rootAspectName: 'inner' });
            }
        }
        const hasAspectId = currentNode.props.id && currentNode.props.id.includes('aspect_');
        const shouldCurrentNodeBeAspectified = !!currentNode.props['data-aspect'] || !!currentNode.props.name || hasAspectId || !!p.rootAspectName;
        if (shouldCurrentNodeBeAspectified) {
            let aspectName = currentNode.props['data-aspect'] || currentNode.props.name;
            if (!aspectName && p.rootAspectName) {
                aspectName = p.rootAspectName;
            }
            if (!aspectName && hasAspectId) {
                aspectName = currentNode.props.id.split('aspect_')[1].split('__')[0];
            }
            const aspect = this.actor.ownAspect[aspectName];
            const aspectifiedChildren = React.Children.map(currentNode.props.children, (c, childIndex) => this.aspectifyJsxTemplate(c, { ...p, rootAspectName: undefined }));
            return (React.createElement(Aspect_, { aspect: aspect, templateComponent: currentNode, key: aspect.name },
                currentNode.type === 'svg' && React.createElement(SvgFilterDefs, { aspect: aspect }),
                aspectifiedChildren,
                innerChildren && aspect === this.actor.inner && innerChildren));
        }
        if (doesCurrentNodeHaveChildren) {
            const aspectifiedChildren = React.Children.map(currentNode.props.children, (c, childIndex) => this.aspectifyJsxTemplate(c, { ...p, rootAspectName: undefined }));
            return_node = React.cloneElement(currentNode, undefined, aspectifiedChildren);
        }
        return return_node;
    }
}
__decorate([
    observable.ref
], ActorRenderer.prototype, "actorComponentChildrenForInnerAspect", void 0);
__decorate([
    computed
], ActorRenderer.prototype, "computedSkeleton", null);
__decorate([
    computed
], ActorRenderer.prototype, "computedSkeletonAsString", null);
__decorate([
    computed
], ActorRenderer.prototype, "computedComponent", null);
__decorate([
    computed
], ActorRenderer.prototype, "computedComponentAsString", null);
